<script setup lang="ts">
import { inputGroupProps } from 'naive-ui';

const props = defineProps(inputGroupProps);
</script>

<template>
  <!-- Joins the borders of adjacent controls into one field — a search box and
       its button, an input with a unit label. Draws no chrome of its own beyond
       that join, but it stays a wrapper so a grouped field never reaches for a
       raw n-* tag, and so the join has somewhere to be tuned. -->
  <n-input-group v-bind="props">
    <slot />
  </n-input-group>
</template>
